import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { LuPlusCircle } from 'react-icons/lu';
import { LevelIndicator } from './LevelIndicator';
import { levelLabels } from './constants';
export const NewItemHandler = React.memo(({ level, onSelect }) => {
    return (_jsxs("div", Object.assign({ className: 'w-100 d-flex justify-content-between opacity-50', onClick: onSelect }, { children: [_jsx(LevelIndicator, { level: level, isLast: true, isSectionExpanded: false }), _jsx("span", Object.assign({ className: 'new-section-style mx-0' }, { children: levelLabels[level] })), _jsx("span", Object.assign({ className: 'end-icons ml-auto px-2' }, { children: _jsx(LuPlusCircle, { size: 16, color: 'rgba(0, 0, 0, 1)' }) }))] })));
});
NewItemHandler.displayName = 'NewItemHandler';
